import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getLocationReviews(locationId, params = {}) {
  return axios.get(`/ajax/locations/${locationId}/reviews`, { params })
}
export function syncLocationReviews(locationId, params = {}) {
  return axios.post(`/ajax/locations/${locationId}/reviews/sync`, params)
}
